module.exports = __webpack_public_path__ + "static/media/logo-armoedefonds.d7b0906a.png";